export const exportFormats = ['CSV', 'TXT', 'PDF'] as const
export type ExportFormatType = (typeof exportFormats)[number]
